import { SharedCallsData } from "@sms/shared/calls/calls.interface";
import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import moment, { Moment } from "moment";

import styles from "./call-list.module.scss";

import { ApplicationStore } from "~/app/application.store";
import { makeSelectCallInfoById } from "~/app/selectors/calls";

export const CallItemComponent: React.FC<{ id: string }> = memo((props: { id: string }) => {
  const selectCallInfoById: (state: ApplicationStore, callId: string) => SharedCallsData | undefined = useMemo(
    () => makeSelectCallInfoById(),
    []
  );

  const call: SharedCallsData | undefined = useSelector((state: ApplicationStore) =>
    selectCallInfoById(state, props.id)
  );

  const today: Moment = moment().endOf("day");
  const date: Moment = moment(call?.created_at);

  const dateFormat: string =
    moment(date).diff(today, "days") === 0
      ? moment(date).format("HH:mm")
      : moment(today).diff(date, "week") === 0
        ? moment(date).format("dddd")
        : moment(date).format("DD.MM.YY");

  return (
    <div className={styles.callItem}>
      <div className={styles.information}>
        <div className={styles.title}>
          <div className={styles.phone}>{`${String(call?.opponentPhone)} ${String(call?.name ? call.name : "")}`}</div>
          <div className={styles.date}>{dateFormat}</div>
        </div>
        <div className={styles.phoneTo}>{call?.activePhone}</div>
      </div>
      {call?.urlRecord && <audio src={call.urlRecord} controls></audio>}
    </div>
  );
});

CallItemComponent.displayName = "CallItemComponent";
